exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".senior-container {\n  width: 100%;\n  padding: 0 8% 40px 8%;\n}\n.senior-container ol li {\n  margin: 10px 0;\n}\n.senior-container .senior-img {\n  width: 800px;\n  margin: 20px  0;\n}\n.senior-container .senior-img img {\n  width: 100%;\n}\n.senior-container .senior-table {\n  width: 60%;\n  margin: 30px  auto;\n}\n.senior-container h2.title {\n  border-left: 4px solid #008bff;\n  height: 20px;\n  line-height: 20px;\n  padding-left: 5px;\n  margin: 0 0 30px 0;\n}\n.senior-container h3 {\n  margin: 20px 0 ;\n}\n.senior-container p {\n  margin-bottom: 15px;\n}\n.senior-container Table {\n  margin-bottom: 20px;\n}\n", ""]);

// exports
